/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import {BrowserRouter, Routes, Route, Outlet} from "react-router-dom";

/* APP */

import AppConfig from './AppConfig';
import { AppContextoReact } from './servicos/app/AppContextoReact';

/* TEMPLATES */

import DashboardLayout from './DashboardLayout';

/* PÁGINAS */

import Login from './pages/login';
import Home from './pages/home';

import ListaProgramas from './pages/programas/listar';

import ListaSeries from './pages/series/listar';

import ListaProdutoras from './pages/produtoras/listar';

import ListaGenero from './pages/genero/listar';

import ListaUsuario from './pages/usuario/listar';

import ListaRepositorio from './pages/repositorio/listar';

/* ESTILIZAÇÃO */

import { ThemeProvider, createTheme } from '@mui/material';
import appTema from './servicos/mui/Theme';
import './styles/Main.scss';

function App()
{
	return <>
		<ThemeProvider theme={createTheme()}>
			<ThemeProvider theme={appTema}>
				<AppContextoReact>
					<BrowserRouter>
						<Routes>
							<Route path={'/'} index element={<Login />} />
							<Route element={<LayoutDashboard />}>
								<Route path={AppConfig.PATHS.Dashboard.home} index element={<ListaProgramas />} />

								<Route path={AppConfig.PATHS.Dashboard.ajuda} element={<Home />} />
								
								<Route path={AppConfig.PATHS.Dashboard.programas.lista + '/:idPrograma?'} element={<ListaProgramas />}/>
										{/* <Route path={AppConfig.PATHS.Dashboard.programas.cadastro} element={<CadastroProgramas />}/> */}
										{/* <Route path={AppConfig.PATHS.Dashboard.programas.editar+'/:idPrograma'} element={<EditarProgramas />}/> */}
								
								<Route path={AppConfig.PATHS.Dashboard.series.lista + '/:idSerie?'} element={<ListaSeries />}/>
										{/* <Route path={AppConfig.PATHS.Dashboard.series.editar+'/:idSerie'} element={<EditarSeries />}/> */}
								
								<Route path={AppConfig.PATHS.Dashboard.produtoras.lista + '/:idProdutora?'} element={<ListaProdutoras />}/>
								
								<Route path={AppConfig.PATHS.Dashboard.genero.lista} element={<ListaGenero />}/>
								
								<Route path={AppConfig.PATHS.Dashboard.usuarios.lista} element={<ListaUsuario />}/>
								
								<Route path={AppConfig.PATHS.Dashboard.repositorio.lista} element={<ListaRepositorio />}/>
							</Route>
						</Routes>
					</BrowserRouter>
				</AppContextoReact>
			</ThemeProvider>
		</ThemeProvider>
	</>
}

export default App;

const LayoutDashboard = () => 
{
	return (
		<DashboardLayout>
			<Outlet />
		</DashboardLayout>
	)
};